import { Component, Input, SimpleChanges, OnChanges, inject, DestroyRef, effect } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass, NgIf } from '@angular/common';
import { EngagementLiteComponent } from '../engagement-lite/engagement-lite.component';
import { EngagementStackbarComponent } from './components/engagement-stackbar/engagement-stackbar.component';
import { EngagementDoughnutChartComponent } from './components/engagement-doughnut-chart/engagement-doughnut-chart.component';
import { EngagementChannelPerformanceComponent } from '../engagement-summary/components/engagement-channel-performance/engagement-channel-performance.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
interface InnerTrendsObject {
  key_as_string: string;
  doc_count: number;
  number_of_request_generated_rated: number;
  number_of_unique_requests_delivered: number;
  number_of_request_generated: number;
  number_of_requests_received: number;
  ignore_this: number;
}
interface TrendsApiResponse {
  [key: string]: InnerTrendsObject;
}
@Component({
    selector: 'app-engagement-pro',
    templateUrl: './engagement-pro.component.html',
    styleUrls: ['./engagement-pro.component.scss'],
    imports: [NgClass, NgIf, EngagementLiteComponent, EngagementStackbarComponent, EngagementDoughnutChartComponent, EngagementChannelPerformanceComponent, LtmsLoaderComponent, LtmsErrorComponent]
})
export class EngagementProComponent implements OnChanges {
  @Input() values: any;
  @Input() isDeviationEnabled = false;
  filters: any = [];
  private Subscription?: Subscription;
  private filtersSubscription?: Subscription;
  private previousHierarchyStackSignature: string = '';
  mainDiscription: string = 'Get a high-level overview of Request Analytics Track trends in request volume and response rate over time, plus access advanced analytics like Records Journey and Channel Performance for deeper insights.';
  isDataAvailable: boolean = false;
  isDataLoaded: boolean = false;
  isChartDataLoaded: boolean = false;
  displayName: string = "";
  project_type: number = 0;
  errorCode: string = '404';
  hierarchyStack: any;
  overall_summary: TrendsApiResponse | [] = [];
  showRecordsJourney: boolean = localStorage.getItem('showRecordsJourney') !== null
  ? JSON.parse(localStorage.getItem('showRecordsJourney')!)
  : false
  showResponseDistribution: boolean = localStorage.getItem('showResponseDistribution') !== null
  ? JSON.parse(localStorage.getItem('showResponseDistribution')!)
  : false
  showChannelPerformance: boolean = localStorage.getItem('showChannelPerformance') !== null
  ? JSON.parse(localStorage.getItem('showChannelPerformance')!)
  : false
  isRecordsJourneyLoaded: boolean = false;
  recordsJourneyData: any = [];
  responseDistribution: any = [];
  destroyRef = inject(DestroyRef);
  dates = {
    startDate: '',
    endDate: ''
  };
  localStorage = localStorage
  restrictToday: boolean = false;
  constructor(
    private helpersService: HelpersService,
    public engagementService: EngagementService,
    private appStateService: AppStateService

  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        let datePickerObj: any = this.appStateService.datePicker();
        this.dates.startDate = datePickerObj.startDate;
        this.dates.endDate = datePickerObj.endDate;
        this.isDataAvailable = true;
        this.hierarchyStack = this.appStateService.hierarchyStack() ? this.appStateService.hierarchyStack() : [];
        const currentSignature = JSON.stringify(this.hierarchyStack || []);
        // If hierarchy stack reset, clear drilldown filters so we don't retain stale filters
        if (this.previousHierarchyStackSignature && this.previousHierarchyStackSignature !== currentSignature) {
          this.engagementService.clearDrilldownHistory();
        }
        this.previousHierarchyStackSignature = currentSignature;
        this.displayName = this.engagementService.getDisplayName();
        let project_type_obj: any = this.appStateService.projectType()
        this.project_type = project_type_obj?.project_type;
        // 
        // 
        if (!this.engagementService.selectedDrilldownFilter) {
          this.isDataLoaded = false;
          // Records Journey
          this.getOverallSummary(2, 'summary', this.dates, null, false, false);
          // Response distribution
          this.getOverallSummary(3, 'summary', this.dates, null, false, false);
        } else {
          this.displayName = this.engagementService.trendDisplayName;
        }
      }
    })

    // this.helpersService.datePicker.subscribe(data => {
    //   if (data) {
    //     this.dates.startDate = data.startDate;
    //     this.dates.endDate = data.endDate;
    //   }
    // })
  }

  ngOnInit() {
    this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate,this.dates.startDate)
    this.isDataLoaded = false;
    this.filtersSubscription = this.engagementService.filters$.subscribe(updatedFilters => {
      this.filters = updatedFilters;
      // Records Journey
      this.getOverallSummaryByFilter(2, 'summary', this.dates, null, false, false);
      // Response distribution
      this.getOverallSummaryByFilter(3, 'summary', this.dates, null, false, false);
      this.displayName = this.engagementService.trendDisplayName;
    });
    // this.helpersService.appState.subscribe(
    //   (response: any) => {
    //     if (response && !response.pending) {
    //       this.isDataAvailable = true;
    //       this.displayName = this.engagementService.getDisplayName();
    //       this.project_type = response?.projectType?.project_type;
    //       // this.filters = []; // reseting temporarily till the drilldown retaintion is developed
    //       // trend details :- RR trend and Request trend
    //       // this.getOverallSummary(1, 'trend', this.dates, null, true, true);
    //       // Records Journey
    //       this.getOverallSummary(2, 'summary', this.dates, null, false, false);
    //       // Response distribution
    //       this.getOverallSummary(3, 'summary', this.dates, null, false, false);
    //       // this.getOverallSummary()
    //     }
    //   }

    // )
  }
  onCheckboxClick(option: string) {
    // Toggle the relevant checkbox and update in localStorage
    if (option === 'recordsJourney') {
      
      this.showRecordsJourney = !this.showRecordsJourney;      
      localStorage.setItem('showRecordsJourney', JSON.stringify(this.showRecordsJourney));
    } 
    if (option === 'responseDistribution') {
      this.showResponseDistribution = !this.showResponseDistribution;
      localStorage.setItem('showResponseDistribution', JSON.stringify(this.showResponseDistribution));
    }
    if (option === 'channelPerformance') {
      this.showChannelPerformance = !this.showChannelPerformance;
      localStorage.setItem('showChannelPerformance', JSON.stringify(this.showChannelPerformance));
    }
  }

  onOptionChange($event: any) {
    this.filters = [];
    this.displayName = this.engagementService.getDisplayName();
    // Records Journey
    this.getOverallSummary(2, 'summary', this.dates, null, false, false);
    // Response distribution
    this.getOverallSummary(3, 'summary', this.dates, null, false, false);
  }

  getOverallSummary(query_type: any, view_type: any, dates: { startDate: string; endDate: string; }, trend_data: any, isLineChart: boolean, isBarChart: boolean) {
    this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate,this.dates.startDate)
    var params = this.engagementService.getSummaryParams({
      "rater_type": -1,
      "query_type": query_type,
      "view_type": view_type,
      "dates": dates,
      "trend_type": (trend_data && trend_data.value) ? trend_data.value : 2,
      "message": (trend_data && trend_data.value) ? "this is for Line graph and bargraph in engagement pro tab" : "this is for stackbar in engagement pro tab",
      "is_deviation_enabled": query_type === 2 ? this.isDeviationEnabled : undefined,
    })
    this.isDataLoaded = false;
    this.isRecordsJourneyLoaded = false;
    if (this.project_type){
      params['project_type'] = this.project_type;
    }
    if (params.to && params.from && !this.restrictToday) {
      this.Subscription = this.engagementService.getEngagementSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response) => {
          if (response &&
            response.code == 0 &&
            response.data.overall_summary_details &&
            (response.data.overall_summary_details &&
              Object.keys(response.data.overall_summary_details).length > 0)
          ) {
            this.isDataAvailable = true;
            this.isDataLoaded = true;
            if (params["view_type"] === 'trend') {
              this.overall_summary = response.data.overall_summary_details.trends
              var trend_name = (trend_data && trend_data.name) ? trend_data.name : ''
              params["message"] = "this is for Line graph and bargraph in engagement pro tab"
              // this.prepareStackedBarData(this.overall_summary);
            }
            if (params["view_type"] === 'summary' && params["query_type"] === 2) {
              this.recordsJourneyData = response.data.overall_summary_details.summary;
              this.isRecordsJourneyLoaded = true;
              params["message"] = "this is for stackbar in engagement pro tab"
            }
            if (params["view_type"] === 'summary' && params["query_type"] === 3) {
              this.responseDistribution = response.data.overall_summary_details.summary
              params["message"] = "this is for doughnut chart in engagement pro tab"
              // this.isData=true
            }
          } else {
            this.isDataAvailable = false;
            this.isDataLoaded = true;
            this.errorCode = '404'
          }
        },
        error: (err) => {
          this.isDataAvailable = false
          this.isDataLoaded = true;
          this.isChartDataLoaded = true;
          if (err.status == '500') {
            this.errorCode = '500'
          } else if (err.status == "408") {
            this.errorCode = '408'
          }
        }
      })
    } else {
      this.isDataLoaded = true;
      this.isChartDataLoaded = true;
    }
  }
  getOverallSummaryByFilter(query_type: any, view_type: any, dates: { startDate: string; endDate: string; }, trend_data: any, isLineChart: boolean, isBarChart: boolean) {
    this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate,this.dates.startDate)
    var params = this.engagementService.getSummaryParams({
      "rater_type": -1,
      "query_type": query_type,
      "view_type": view_type,
      "dates": dates,
      "filters": this.filters,
      "trend_type": (trend_data && trend_data.value) ? trend_data.value : 2,
      "message": (trend_data && trend_data.value) ? "this is for Line graph and bargraph in engagement pro tab" : "this is for stackbar in engagement pro tab",
      "is_deviation_enabled": query_type === 2 ? this.isDeviationEnabled : undefined,
    })
    if (this.filters?.brand_id){
      params.brand_id = this.filters.brand_id;
    }
    if (this.filters?.brand_id_list){
      params.brand_id_list = this.filters?.brand_id_list;
    }
    if (this.project_type){
      params['project_type'] = this.project_type;
    }
    
    if (params.to && params.from && !this.restrictToday) {
      this.isChartDataLoaded = false;
      this.Subscription = this.engagementService.getEngagementSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response) => {
          if (response &&
            response.code == 0 &&
            response.data.overall_summary_details &&
            (response.data.overall_summary_details &&
              Object.keys(response.data.overall_summary_details).length > 0)
          ) {
            this.isDataAvailable = true;
            this.isDataLoaded = true;
            this.isChartDataLoaded = true;
            if (params["view_type"] === 'summary' && params["query_type"] === 2) {
              this.recordsJourneyData = response.data.overall_summary_details.summary;
              params["message"] = "this is for stackbar in engagement pro tab with filter"
            }
            if (params["view_type"] === 'summary' && params["query_type"] === 3) {
              this.responseDistribution = response.data.overall_summary_details.summary
              params["message"] = "this is for doughnut chart in engagement pro tab with filter"
            }
          } else {
            this.isDataAvailable = false;
            this.isDataLoaded = true;
            this.isChartDataLoaded = true;
            this.errorCode = '404'
          }
        },
        error: (err) => {
          this.isDataAvailable = false
          this.isDataLoaded = true;
          this.isChartDataLoaded = true;
          if (err.status == '500') {
            this.errorCode = '500'
          } else if (err.status == "408") {
            this.errorCode = '408'
          }
        }
      })
    } else {
      this.isChartDataLoaded = true;
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDeviationEnabled'] && !changes['isDeviationEnabled'].firstChange && this.dates?.startDate) {
      this.getOverallSummary(2, 'summary', this.dates, null, false, false);
    }
  }

  ngOnDestroy(): void {
    // we've destroyed the component, so update the subject
    this.Subscription?.unsubscribe()
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }
    this.engagementService.clearDrilldownHistory();
    this.engagementService.selectedRaterType = {};
  }
}